import React from 'react';

function AdjustIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 4v10m0 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 6v-.5M17.5 4v5m0 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 11v-5.56M6.5 4v2m0 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 14v-8.44"
        opacity="0.5"
      ></path>
    </svg>
  );
}

export default AdjustIcon;
